(function () {
  'use strict';

  var EXCHANGE_HANDLE = 'trocas-assinantes';
  var SESSION_KEY = 'nrc_exchange_product_ids';
  var MSG_BLOCKED = 'Você já realizou sua troca este mês e não pode adicionar itens de troca.';
  var MSG_REMOVED = 'Item de troca anterior removido. Apenas 1 item de troca é permitido.';
  var MSG_QTY_LIMIT = 'Itens de troca são limitados a 1 unidade por pedido.';
  var MSG_NOT_ELIGIBLE = 'Estes produtos são exclusivos para assinantes com cupom de troca disponível.';
  var _toastTimer = null;
  var _enforcing = false;

  var _nativeFetch = window.fetch.bind(window);
  window._nrcNativeFetch = _nativeFetch;

  function fetchExchangeIds() {
    var preloaded = window._nrcExchangeProductIds;
    if (preloaded && preloaded.length) {
      return Promise.resolve(preloaded);
    }
    var cached = sessionStorage.getItem(SESSION_KEY);
    if (cached) {
      try { return Promise.resolve(JSON.parse(cached)); } catch (e) { }
    }
    return _nativeFetch('/collections/' + EXCHANGE_HANDLE + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var ids = (data.products || []).map(function (p) { return p.id; });
        if (ids.length) sessionStorage.setItem(SESSION_KEY, JSON.stringify(ids));
        return ids;
      });
  }

  function trocaRealizada() {
    var c = window._nrcCustomer;
    return !!(c && (c.trocaRealizada === true || c.trocaRealizada === 'true'));
  }

  // Cliente logado + tag 'assinante' + metafield custom.cupom_gerado preenchido
  // (calculado server-side em layout/theme.liquid, window._nrcCustomer.exchangeEligible).
  function isExchangeEligible() {
    var c = window._nrcCustomer;
    return !!(c && (c.exchangeEligible === true || c.exchangeEligible === 'true'));
  }

  // Nenhum item de troca pode ficar no carrinho quando o cliente não é elegível
  // ou já usou a troca do mês.
  function denyAllExchangeItems() {
    return trocaRealizada() || !isExchangeEligible();
  }

  function denyMessage() {
    if (!isExchangeEligible()) return MSG_NOT_ELIGIBLE;
    if (trocaRealizada()) return MSG_BLOCKED;
    return MSG_QTY_LIMIT;
  }

  // Sync check used by the cart drawer/page UI (Liquid/Alpine bindings).
  window._nrcIsExchange = function (productId) {
    var ids = window._nrcExchangeProductIds || [];
    return ids.indexOf(productId) !== -1;
  };

  // Post-add: enforces exchange rules.
  // - denyAll = true  → remove ALL exchange items (não elegível ou troca já usada)
  // - denyAll = false → keep newest (index 0) at qty 1, remove older extras
  // Returns { removed: bool, blocked: bool, notEligible: bool }
  function enforceExchangeLimit() {
    if (_enforcing) return Promise.resolve({ removed: false, blocked: false, notEligible: false });
    _enforcing = true;
    var blocked = trocaRealizada();
    var notEligible = !isExchangeEligible();
    var denyAll = blocked || notEligible;
    return fetchExchangeIds()
      .then(function (exchangeIds) {
        return _nativeFetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var exchangeItems = (cart.items || []).filter(function (item) {
              return exchangeIds.indexOf(item.product_id) !== -1;
            });
            if (!exchangeItems.length) {
              _enforcing = false;
              return { removed: false, blocked: false, notEligible: false };
            }
            var changes = [];
            if (denyAll) {
              exchangeItems.forEach(function (item) {
                changes.push({ key: item.key, quantity: 0 });
              });
            } else {
              // keep first item at qty 1, remove the rest entirely
              if (exchangeItems[0].quantity > 1) {
                changes.push({ key: exchangeItems[0].key, quantity: 1 });
              }
              exchangeItems.slice(1).forEach(function (item) {
                changes.push({ key: item.key, quantity: 0 });
              });
            }
            if (!changes.length) {
              _enforcing = false;
              return { removed: false, blocked: false, notEligible: false };
            }
            var chain = Promise.resolve();
            changes.forEach(function (change) {
              chain = chain.then(function () {
                return _nativeFetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: change.key, quantity: change.quantity })
                });
              });
            });
            return chain.then(function () {
              _enforcing = false;
              return { removed: true, blocked: blocked, notEligible: notEligible };
            });
          });
      })
      .catch(function (err) {
        _enforcing = false;
        console.warn('[cart-exchange-limit]', err);
        return { removed: false, blocked: false, notEligible: false };
      });
  }

  // Pre-flight clamp for quantity edits (/cart/change.js, /cart/update.js).
  // Rewrites the request body BEFORE it is sent, so the response — cart JSON
  // and any Section Rendering HTML the theme swaps in — already reflects the
  // enforced quantity. Post-hoc cleanup would leave the re-rendered cart
  // showing the rejected quantity until the next reload.
  // Resolves to the corrected body string, or null when nothing needs clamping.
  function clampCartMutation(url, bodyText) {
    var body;
    try { body = JSON.parse(bodyText); } catch (e) { return Promise.resolve(null); }

    var isChange = url.indexOf('/cart/change') !== -1;
    var wantsIncrease = false;
    if (isChange) {
      wantsIncrease = parseInt(body.quantity, 10) > 1;
    } else if (body.updates) {
      var values = Array.isArray(body.updates)
        ? body.updates
        : Object.keys(body.updates).map(function (k) { return body.updates[k]; });
      wantsIncrease = values.some(function (q) { return parseInt(q, 10) > 1; });
    }
    if (!wantsIncrease) return Promise.resolve(null);

    var maxQty = denyAllExchangeItems() ? 0 : 1;

    return fetchExchangeIds().then(function (exchangeIds) {
      if (!exchangeIds.length) return null;
      return _nativeFetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          function findItem(ref) {
            var refStr = String(ref);
            for (var i = 0; i < cart.items.length; i++) {
              var it = cart.items[i];
              if (it.key === refStr || String(it.variant_id) === refStr || String(it.id) === refStr) return it;
            }
            return null;
          }
          function isExchange(item) {
            return !!item && exchangeIds.indexOf(item.product_id) !== -1;
          }

          var changed = false;
          if (isChange) {
            var item = (body.line !== undefined)
              ? (cart.items[parseInt(body.line, 10) - 1] || null)
              : findItem(body.id);
            if (isExchange(item) && parseInt(body.quantity, 10) > maxQty) {
              body.quantity = maxQty;
              changed = true;
            }
          } else if (Array.isArray(body.updates)) {
            body.updates = body.updates.map(function (q, i) {
              if (parseInt(q, 10) > maxQty && isExchange(cart.items[i])) {
                changed = true;
                return maxQty;
              }
              return q;
            });
          } else {
            Object.keys(body.updates).forEach(function (key) {
              if (parseInt(body.updates[key], 10) > maxQty && isExchange(findItem(key))) {
                body.updates[key] = maxQty;
                changed = true;
              }
            });
          }
          return changed ? JSON.stringify(body) : null;
        });
    }).catch(function (err) {
      console.warn('[cart-exchange-limit]', err);
      return null;
    });
  }

  function showToast(msg) {
    var el = document.getElementById('nrc-exchange-toast');
    if (el) el.remove();
    if (_toastTimer) clearTimeout(_toastTimer);
    el = document.createElement('div');
    el.id = 'nrc-exchange-toast';
    el.textContent = msg;
    Object.assign(el.style, {
      position: 'fixed', bottom: '28px', left: '50%',
      transform: 'translateX(-50%)', background: '#111', color: '#fff',
      padding: '12px 20px', fontSize: '13px', fontFamily: 'inherit',
      letterSpacing: '.03em', zIndex: '99999', pointerEvents: 'none',
      opacity: '0', transition: 'opacity .2s', whiteSpace: 'nowrap'
    });
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.style.opacity = '1'; });
    _toastTimer = setTimeout(function () {
      el.style.opacity = '0';
      setTimeout(function () { if (el.parentNode) el.remove(); }, 250);
    }, 4500);
  }

  function getUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function getMethod(input, init) {
    if (init && init.method) return init.method.toUpperCase();
    if (input && typeof input.method === 'string') return input.method.toUpperCase();
    return 'GET';
  }

  // Post-add blocking: the theme receives the fetch response only AFTER cleanup is done.
  // When the theme then dispatches label:modalcart:afteradditem and the drawer fetches
  // /cart.js, it already sees the correct single-item state.
  window.fetch = function (input, init) {
    var url = getUrl(input);
    var method = getMethod(input, init);

    if (method !== 'POST') {
      return _nativeFetch(input, init);
    }

    if (url.indexOf('/cart/add') !== -1) {
      return _nativeFetch(input, init)
        .then(function (response) {
          var clone = response.clone();
          return enforceExchangeLimit()
            .then(function (result) {
              if (result.notEligible) showToast(MSG_NOT_ELIGIBLE);
              else if (result.blocked) showToast(MSG_BLOCKED);
              else if (result.removed) showToast(MSG_REMOVED);
              return clone;
            })
            .catch(function () {
              return clone;
            });
        });
    }

    if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
      if (init && typeof init.body === 'string') {
        return clampCartMutation(url, init.body).then(function (newBody) {
          if (newBody === null) return _nativeFetch(input, init);
          showToast(denyMessage());
          var newInit = Object.assign({}, init, { body: newBody });
          return _nativeFetch(input, newInit);
        });
      }
      // Body not inspectable (FormData/Request) — fix server state after the fact.
      return _nativeFetch(input, init).then(function (response) {
        return enforceExchangeLimit()
          .then(function (result) {
            if (result.notEligible) showToast(MSG_NOT_ELIGIBLE);
            else if (result.blocked) showToast(MSG_BLOCKED);
            else if (result.removed) showToast(MSG_QTY_LIMIT);
            return response;
          })
          .catch(function () {
            return response;
          });
      });
    }

    return _nativeFetch(input, init);
  };

  // XHR fallback (fire-and-forget — XHR cannot be paused)
  var OriginalXHR = window.XMLHttpRequest;
  function PatchedXHR() {
    var self = new OriginalXHR();
    var origOpen = self.open.bind(self);
    var origSend = self.send.bind(self);
    var _method = '', _url = '';
    self.open = function (method, url) {
      _method = (method || '').toUpperCase();
      _url = url || '';
      return origOpen.apply(self, arguments);
    };
    self.send = function (body) {
      if (_method === 'POST' && (_url.indexOf('/cart/add') !== -1 || _url.indexOf('/cart/change') !== -1 || _url.indexOf('/cart/update') !== -1)) {
        setTimeout(function () { enforceExchangeLimit(); }, 600);
      }
      return origSend.apply(self, arguments);
    };
    return self;
  }
  PatchedXHR.prototype = OriginalXHR.prototype;
  window.XMLHttpRequest = PatchedXHR;

  // Autocura ao carregar a página: cobre carrinho com item de troca de uma
  // sessão anterior cuja elegibilidade mudou nesse meio-tempo (cupom usado/
  // expirado, tag removida, logout/login com outro cliente etc.).
  document.addEventListener('DOMContentLoaded', function () {
    enforceExchangeLimit().then(function (result) {
      if (result.notEligible) showToast(MSG_NOT_ELIGIBLE);
      else if (result.blocked) showToast(MSG_BLOCKED);
      else if (result.removed) showToast(MSG_REMOVED);
    });
  });

})();
